import React, { useState, useRef, useEffect } from 'react';
import '../styles/CharacterSelection.css';

// Character data with renamed characters
const characters = [
  { id: 'rpmgirl', name: 'Scarlett', thumbnail: '/thumbnails/rpmgirl.png' },
  { id: 'rpmsigma', name: 'Marcus', thumbnail: '/thumbnails/rpmsigma.png' },
  { id: 'rpmorangie', name: 'Orangie', thumbnail: '/thumbnails/rpmorangie.png' }, // Kept as is
  { id: 'rpmcharacter2', name: 'Musk', thumbnail: '/thumbnails/rpmelon.png' }, // Kept as is
  { id: 'rpmgirl2', name: 'Victoria', thumbnail: '/thumbnails/rpmgirl2.png' },
  { id: 'rpmgirl3', name: 'Emma', thumbnail: '/thumbnails/rpmgirl3.png' },
  { id: 'rpmgirl4', name: 'Luna', thumbnail: '/thumbnails/rpmgirl4.png' },
  { id: 'rpmgirl5', name: 'Sophia', thumbnail: '/thumbnails/rpmgirl5.png' },
  { id: 'rpmtrump', name: 'Donald', thumbnail: '/thumbnails/rpmtrump.png' },
  { id: 'rpmnig', name: 'Jerome', thumbnail: '/thumbnails/rpmnig.png' }
];

export const CharacterSelection = ({ onCharacterSelected, registrationError }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const usernameInputRef = useRef(null);
  const contentRef = useRef(null);

  // Update local error state when props change
  useEffect(() => {
    if (registrationError) {
      setError(registrationError);
    }
  }, [registrationError]);

  // Scroll to username input when a character is selected
  useEffect(() => {
    if (selectedId && usernameInputRef.current) {
      setTimeout(() => {
        usernameInputRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        usernameInputRef.current.focus();
      }, 300);
    }
  }, [selectedId]);

  const handleSelect = (characterId) => {
    setSelectedId(characterId);
    
    // If we're in standalone character selection mode, notify the parent
    if (!usernameInputRef.current) {
      onCharacterSelected(characterId);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Local validation for empty username
    if (!username.trim()) {
      setError('Username cannot be empty');
      return;
    }
    
    // Local validation for username length
    if (username.trim().length < 3) {
      setError('Username must be at least 3 characters');
      return;
    }
    
    // Clear error before submission
    setError('');
    
    if (selectedId && username.trim()) {
      // Only pass username if we're in registration mode
      if (usernameInputRef.current) {
        onCharacterSelected(selectedId, username);
      }
    }
  };

  // Determine if we're in registration mode (with username input) or just character selection
  const isRegistrationMode = onCharacterSelected.length > 1 || typeof onCharacterSelected === 'function';

  return (
    <div className="character-selection-overlay">
      <div className="character-selection-content" ref={contentRef}>
        <h2 className="selection-heading">Choose Your Character</h2>

        <div className="character-grid">
          {characters.map(character => (
            <div
              key={character.id}
              className={`character-card ${selectedId === character.id ? 'selected' : ''}`}
              onClick={() => handleSelect(character.id)}
            >
              {character.thumbnail ? (
                <img src={character.thumbnail} alt={character.name} className="character-image" />
              ) : (
                <div className="character-placeholder">
                  <div className="character-icon">{character.name.charAt(0)}</div>
                </div>
              )}
              <div className="character-name">{character.name}</div>
            </div>
          ))}
        </div>

        {isRegistrationMode && (
          <>
            <div className="username-container">
              <input
                type="text"
                placeholder="Create a unique username"
                className={`username-input ${error ? 'has-error' : ''}`}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                ref={usernameInputRef}
              />
              
              {/* Display error message if present */}
              {error && (
                <div className="username-error">
                  {error}
                </div>
              )}
            </div>

            <button
              className="registration-button"
              disabled={!selectedId || !username.trim()}
              onClick={handleSubmit}
            >
              Complete Registration
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CharacterSelection;